import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Spinner from "react-bootstrap/Spinner";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Home from "./Home";
import LoHome from "./LoHome";

// Suppress React Router Future Flags Warning in development
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (
      args[0] &&
      (args[0].includes('React Router Future Flag Warning') || 
       args[0].includes('Relative route resolution within Splat routes'))
    ) {
      return; // Suppress specific React Router warnings
    }
    originalWarn(...args); // Allow other warnings to be logged
  };
}

function App() {
  const appVersion = appversion.version;
  const baseName = process.env.REACT_APP_BASENAME;

  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true}
      isVerboseMode={false}
      metaFileDirectory={process.env.PUBLIC_URL}
    >
      <BrowserRouter basename={baseName} future={{v7_startTransition:true, v7_relativeSplatPath:true}}>
        <Suspense
          fallback={
            <div className="text-center">
              {/* <Spinner /> */} {/* You can uncomment this spinner if needed */}
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:agentName" element={<LoHome />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </CacheBuster>
  );
}

export default App;
